<script setup>
import ActionButton from '../src/index.vue'
import { extActionButtonProps } from '../src/props.js'

defineProps(extActionButtonProps)
</script>

<template>
  <ActionButton
    :editor="editor"
    :action="() => editor.chain().focus().toggleItalic().run()"
    :is-active="() => editor.isActive('italic') || false"
    :disabled="!editor.can().toggleItalic()"
    :tooltip="t('editor.italic.tooltip')"
    icon="italic"
  />
</template>
